import { createSelector } from "reselect";
const selector = (state) => state.notifications;

export default createSelector([selector], (data) => data);